import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import {
  Box,
  Button,
  useTheme,
  Typography,
  Card,
  CardContent,
  Badge,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import warningStore from "../stores/WarningStore";
import WarningNotification from "../component/warning-components/WarningNotification";

const DescriptionTab = () => (
  <Box className="flex items-center justify-center min-h-[60vh]">
    <Typography variant="h5">Description Tab - Coming Soon</Typography>
  </Box>
);

const Warning = observer(() => {
  const [activeTab, setActiveTab] = useState("Description");
  const theme = useTheme();

  const tabDescriptions = {
    Description: "Overview and details about the warning system",
    Notification: "View and manage warning notifications",
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case "Description":
        return <DescriptionTab />;
      case "Notification":
        return <WarningNotification />;
      default:
        return null;
    }
  };

  return (
    <>
      {/* Tab Buttons */}
      <Box className="flex gap-2 mb-4">
        {["Description", "Notification"].map((tab) => (
          <Box
            key={tab}
            sx={{
              borderBottom: "2px solid",
              borderColor:
                activeTab === tab
                  ? theme.palette.mode === "dark"
                    ? theme.palette.primary.main
                    : "#22C55E"
                  : "transparent",
            }}
          >
            <Button
              onClick={() => setActiveTab(tab)}
              sx={{
                textTransform: "none",
                color:
                  activeTab === tab
                    ? theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : "#000000"
                    : "text.primary",
              }}
            >
              {tab === "Notification" ? (
                <Badge
                  badgeContent={warningStore.unreadWarningIds.length}
                  color="error"
                  invisible={warningStore.unreadWarningIds.length === 0}
                >
                  {tab}
                </Badge>
              ) : (
                tab
              )}
            </Button>
          </Box>
        ))}
      </Box>

      <Box sx={{ p: 3 }}>
        {/* Header Card */}
        <Card
          elevation={3}
          sx={{
            mb: 4,
            p: 2,
            background: "#F3F4F6",
            borderLeft: "4px solid #22C55E",
          }}
        >
          <CardContent>
            <Box display="flex" alignItems="center" mb={1}>
              <WarningAmberIcon
                fontSize="large"
                sx={{ mr: 2, color: "#22C55E" }}
              />
              <Typography variant="h4" fontWeight="bold">
                {activeTab}
              </Typography>
            </Box>
            <Typography color="text.secondary">
              {tabDescriptions[activeTab]}
            </Typography>
          </CardContent>
        </Card>
      </Box>

      {/* Render Active Tab Content */}
      {renderActiveTab()}
    </>
  );
});

export default Warning;
